import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import BigHierarchyMultipicklistControl
  from 'Components/ComponentLibrary/Components/Inputs/Multipicklist/BigHierarchyMultipicklistControl';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import ExpenseStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingSelectRecurringExpenses/ExpenseStepHeader';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import MiscItemSection
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingSelectRecurringExpenses/MiscItemSection';

function OnboardingSelectRecurringExpenses() {
  const { onboardingStepResource, setOnboardingStepCollection } = useSurveyContext();
  const {
    resource,
    handleChange,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  useScrollTopOnMount();
  const { displayErrorMessage } = useSnackbarContext();

  const handleAddNewExpense = async (rel) => {
    try {
      await rel.link('related').post({});
      const preRefreshOptions = onboardingStepResource.attr('options');
      const onboardingStepCollection = await onboardingStepResource.link('self').get();
      onboardingStepCollection.resources().head().attr('options', preRefreshOptions); // we need to preserve options pre refresh so that we don't lose them
      setOnboardingStepCollection(onboardingStepCollection);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to add new expense');
    }
  };

  const iconMapper = (groupName) => {
    switch (groupName) {
      case 'Home':
        return 'houseChimneyWindow';
      case 'Utilities':
        return 'plug';
      case 'Transportation':
        return 'carBus';
      case 'Food':
        return 'potFood';
      case 'Family & pets':
        return 'paw';
      case 'Health & wellness':
        return 'spa';
      case 'Shopping & entertainment':
        return 'shopping';
      case 'Giving & gifts':
        return 'gifts';
      case 'Debt':
        return 'creditCardSolid';
      case 'Other':
        return 'rectanglesMixed';
      default:
        return 'add';
    }
  };

  if (!resource) return null;
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDStack direction={'column'} spacing={4}>
        <ExpenseStepHeader resource={resource} />
        <FDStack direction={'column'} spacing={5}>
          <BigHierarchyMultipicklistControl
            options={resource.meta().field('options').options().list()}
            value={resource?.attr('options') || []}
            onChange={(value) => {
              return handleChange('options', value);
            }}
            iconMapper={iconMapper}
            testName={'expenses'}
            searchLabel={'Search expense categories'}
            isLegacy={false}
          />
          <MiscItemSection resources={resource.attr('miscItems').resources().list()} />
        </FDStack>
        <OnboardingAddItemButton relationship={resource.relationship(fr.relationships.addItem.name)} onAdd={handleAddNewExpense} />
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
        nextButtonLabel={'Continue'}
        NextButtonProps={{
          disabled: resource?.attr('options')?.length === 0,
        }}
      />
    </FDStack>
  );
}

OnboardingSelectRecurringExpenses.propTypes = {
};

OnboardingSelectRecurringExpenses.defaultProps = {
};

export default OnboardingSelectRecurringExpenses;
